import styled from "styled-components";
import { Button as ButtonAntd } from "antd";
import { COLORS } from "../../../layout/theme";

export const ButtonContainer = styled.div``;

export const AntdButton = styled(ButtonAntd)`
	background-color: ${(props) =>
		props.$active ? COLORS.Primary : COLORS.White};
	color: ${(props) => (props.$active ? COLORS.White : COLORS.Primary)};
	border-color: ${COLORS.Primary};
	border-radius: 5px;
	${(props) =>
		props.height &&
		`
      height: ${props.height}px;
    `}
	${(props) =>
		props.width &&
		`
      width: ${props.width}px;
    `}
  ${(props) => props.fontSize && `font-size: ${props.fontSize}px`}
`;
export const ChildrenContainer = styled.div`
	margin-top: 20px;
`;
